export class Notice {
    message: string;
    noticeType = 'alert-info';
    icon = 'info_outline';
    title = 'information';
    close = 'close';
    classes: string;
    state = 'fadeOut';
    styles = {top: '2em'};
    id: number;

    private _classesArray = ['alert-info', 'col-md-6', 'col-md-offset-3', 'alert', 'alert-with-icon'];

    constructor( message: string, cssClass: string = 'alert-info' ) {
        this.message = message;
        this._classesArray[0] = cssClass;
        this.classes = this._classesArray.join( ' ' );
    }
}

export class InfoNotice extends Notice {
    constructor( message: string ) {
        super(message);
    }
}

export class ErrorNotice extends Notice {
    title = 'error';
    constructor( message: string = 'defaultError' ) {
        super(message, 'alert-danger');
    }
}

export class SuccessNotice extends Notice {
    title = 'success';

    constructor( message: string = 'success' ) {
        super(message, 'alert-success');
    }
}

export class WarningNotice extends Notice {
    title = 'warning';

    constructor( message: string ) {
        super(message, 'alert-warning');
    }
}
